module.exports = __webpack_public_path__ + "img/26.1b1227d2.png";